export default __webpack_public_path__ + "static/media/presents.998ecb63.png";